import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import GemCard from '../components/GemCard';
import { fetchGems, getImageUrl } from '../api';
import './GemType.css';

const GEM_DESCRIPTIONS = {
  'RUBY': 'Ruby is one of the rarest and most desired gemstones, known for its deep red color and timeless beauty. The Natural Gem offers a wide selection of naturally colored, untreated rubies, showcasing a variety of hues, origins, and unique characteristics.',
  'BLUE SAPPHIRE': 'Blue Sapphire is one of the most prized gemstones in the world, beloved for its deep celestial blue. Sri Lanka produces some of the finest blue sapphires, known for their exceptional clarity and vivid color.',
  'EMERALD': 'Emerald is the stone of spring and rebirth, valued for its lush green color. These precious stones represent nature at its finest, with each gem carrying a unique fingerprint of inclusions known as its garden.',
  'DEFAULT': 'Discover our exquisite collection of natural gemstones, each carefully selected for their exceptional quality, color, and clarity. All gems are certified and sourced ethically from Sri Lanka.'
};

const GEM_BG_COLORS = {
  'RUBY': 'linear-gradient(135deg, #1a0000 0%, #4a0000 100%)',
  'BLUE SAPPHIRE': 'linear-gradient(135deg, #000d1a 0%, #003366 100%)',
  'EMERALD': 'linear-gradient(135deg, #001a00 0%, #004d00 100%)',
  'DEFAULT': 'linear-gradient(135deg, #1a1a1a 0%, #333 100%)',
};

export default function GemType() {
  const { typeName } = useParams();
  const navigate = useNavigate();
  const decodedType = decodeURIComponent(typeName);
  const [gems, setGems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGems({ gemType: decodedType })
      .then(data => {
        setGems(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [decodedType]);

  const bg = GEM_BG_COLORS[decodedType] || GEM_BG_COLORS['DEFAULT'];
  const desc = GEM_DESCRIPTIONS[decodedType] || GEM_DESCRIPTIONS['DEFAULT'];

  return (
    <div className="gemtype-page">
      <Navbar />

      {/* Hero Section */}
      <div className="gemtype-hero" style={{ background: bg }}>
        <button className="gemtype-back-btn" onClick={() => navigate(-1)}>‹</button>
        <h1 className="gemtype-title">{decodedType}</h1>
        <div className="gemtype-gems-preview">
          {gems.slice(0, 3).map(gem => (
            <div key={gem._id} className="gemtype-preview-img">
              <img src={getImageUrl(gem.image)} alt={gem.name} />
            </div>
          ))}
          {gems.length === 0 && !loading && (
            <div className="gemtype-placeholder-gems">
              <div className="gem-orb" />
              <div className="gem-orb" />
              <div className="gem-orb" />
            </div>
          )}
        </div>
      </div>

      {/* Description */}
      <div className="gemtype-desc-section">
        <p className="gemtype-desc">{desc}</p>
      </div>

      {/* Gem Grid */}
      <div className="gemtype-grid-section">
        {loading ? (
          <div className="gemtype-grid">
            {Array(6).fill(0).map((_, i) => <div key={i} className="skeleton-card" />)}
          </div>
        ) : gems.length === 0 ? (
          <div className="no-gems-msg">
            <p>No {decodedType} gems are currently available. Check back soon!</p>
          </div>
        ) : (
          <div className="gemtype-grid">
            {gems.map(gem => <GemCard key={gem._id} gem={gem} />)}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
